import type {
  StandardTextFieldProps,
  TextFieldProps,
} from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import type { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers';
import type { PickersTextFieldProps } from '@mui/x-date-pickers';

export type DatePickerProps = MuiDatePickerProps & {
  variant?:
    | TextFieldProps['variant']
    | 'white-filled'
    | 'white-filled-outlined';
};

export function DatePicker({
  variant,
  slotProps,
  ...pickerProps
}: DatePickerProps) {
  const theme = useTheme();
  const { spacing, palette } = theme;

  const isWhiteFilledVariant =
    variant === 'white-filled' || variant === 'white-filled-outlined';

  const textFieldSx = (slotProps?.textField as PickersTextFieldProps)?.sx;

  const textFieldVariant = isWhiteFilledVariant ? 'filled' : variant;

  return (
    <MuiDatePicker
      {...pickerProps}
      slotProps={{
        ...slotProps,
        textField: {
          ...slotProps?.textField,
          variant: textFieldVariant as StandardTextFieldProps['variant'],
          sx: {
            ...(typeof textFieldSx === 'function'
              ? textFieldSx(theme)
              : textFieldSx),
            ...(isWhiteFilledVariant && {
              '& .MuiPickersInputBase-root, & .MuiPickersInputBase-root.Mui-focused':
                {
                  backgroundColor: palette.background.default,
                  borderRadius: spacing(1),
                },
              ...(variant === 'white-filled-outlined' && {
                '& .MuiPickersInputBase-root': {
                  border: '1px solid',
                  borderColor: 'divider',
                },
              }),
              '& .MuiPickersInputBase-root:hover': {
                backgroundColor: palette.primary.lighter,

                '&:before, &:after': {
                  borderBottom: 0,
                },
              },
            }),
          },
        },
      }}
    />
  );
}
